import React from 'react';
import HeroBanner from './taxServicesComponents/hero-banner';
import TaxPackages from './taxServicesComponents/tax-packages';
import usePageTitle from '../usePageTitle';

export default function TaxServices() {
    usePageTitle({
        title: 'TaxObey | Tax Services',
        description: 'Explore TaxObey tax services including registration support, individual income tax guidance, and business tax compliance packages.',
        path: '/tax-services',
    });

    return (
        <div className="tax-services">
            <HeroBanner />
            <TaxPackages />
        </div>
    );
}